import React, { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import FlagIcon from "@material-ui/icons/Flag";
import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const UrgentToggleButton = ({ ticket }) => {
  const [loading, setLoading] = useState(false);
  const isUrgent = !!ticket.isUrgent;

  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}/urgent`, { isUrgent: !isUrgent });
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title={isUrgent ? "Remover urgência" : "Marcar como urgente"} arrow>
      <IconButton size="small" onClick={handleToggle} disabled={loading}>
        {isUrgent ? (
          <FlagIcon style={{ color: "#f44336" }} fontSize="small" />
        ) : (
          <FlagOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default UrgentToggleButton;
